export const isNavDatePickerModalOpen = state => state.navDatePickerModal;
export const isSuccessModalOpen = state => state.successModal;
export const successMessage = state => state.successModalMessage;
export const isLoadingIndicatorOpen = state => state.loadingIndicator;
export const isInvoiceDetailDialogOpen = state => state.invoiceDetailDialog;
export const isPrintConfirmDialogOpen = state => state.printConfirmDialog;
export const detailsToShow = state => state.invoiceDetailsItem;
export const databaseUri = state => state.dbUri;
export const user = state => state.currentUser;
export const unauthNavigationAttempt = state => state.unauthNavAttemptUrl;

export const wasNewClientAdded = state => state.newClientWasAdded;

export const categories = state => state.categorias;

export const allServices = state => state.servicios;

export const allProducts = state => state.productos;

export const servicesByCategory = (state) => (categoryID) => {
  const filteredServices = state.servicios.filter(
    servicio => servicio.id_categoria === categoryID
  );
  return filteredServices;
};

export const productsByCategory = (state) => (categoryID) => {
  const filteredProducts = state.productos.filter(
    producto => producto.id_categoria === categoryID
  );
  return filteredProducts;
};

export const chargeBillModal = state => state.isChargeBillModalOpen;

export const entregarServicioModal = state => state.isEntregarServicioModalOpen;

export const selectedInvoices = state => state.invoicesToCharge;
